import { withStyles } from '@material-ui/core';
import TimerIcon from '@material-ui/icons/TimerOutlined';
import { getHoursMinutesAndSecondsStr } from './utils';

const styles = (theme) => ({
  container: {
    display: 'flex',
    color: theme.iconColor,
    alignItems: 'center',
    justifyContent: 'center'
  },
  timerIcon: {
    fontSize: 19,
    marginRight: 2
  },
  timerValueItalic: {
    fontSize: 16,
    fontStyle: 'italic',
    fontWeight: 400
  },
  timerValue: {
    fontSize: theme.headerTextFontSize,
    color: theme.TextColor,
    fontStyle: 'normal',
    fontWeight: 400
  },
  time: {
    marginLeft: 4,
    fontWeight: 600
  }
});

const Timer = ({ classes, label, timeInSeconds, useNormalStyle = false }) => (
  <div className={classes.container}>
    {!useNormalStyle && <TimerIcon className={classes.timerIcon} />}
    <span className={`${classes.timerValueItalic} ${useNormalStyle ? classes.timerValue : ''}`}>
      {label}
      <span className={classes.time}>
        {timeInSeconds === undefined ? 'updating...' : getHoursMinutesAndSecondsStr(timeInSeconds)}
      </span>
    </span>
  </div>
);

export default withStyles(styles)(Timer);
